import { Component, Input } from '@angular/core';
@Component({
    selector: 'app-section',
    templateUrl: './app-section.component.html',
    styleUrls: ['./app-section.component.scss'],
    standalone: false
})
export class AppSectionComponent {
  @Input()
  mobile = false;

  @Input()
  first = false;

  @Input()
  titleBackground = true;

  @Input() category: AppSectionCategory = AppSectionCategory.MAIN_SECTION;

  @Input() sectionIcon: string;
  @Input() sectionTitle: string;

  @Input() topDivider: boolean = false;

  constructor() {}
}

export enum AppSectionCategory {
  MAIN_SECTION = 'MAIN_SECTION',
  SUB_SECTION = 'SUB_SECTION',
}
